import { NgModule } from '@angular/core';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { LoginService } from '../login/login.service';
import { environment } from '../../../../environments/environment';
import { AutenticacaoCustom } from '../../model/autenticacaoCustom';

export function authHttpServiceFactory(loginService: LoginService) {

    return {
        tokenGetter: () => {

            if (AutenticacaoCustom.autenticacao !== undefined && AutenticacaoCustom.autenticacao !== null) {
                const aux = AutenticacaoCustom.autenticacao;
                AutenticacaoCustom.setAutenticacaoCustom(null);
                return aux;
            }
            loginService.reloginSePertoDeExpirar();
            return localStorage.getItem('token');
        },
        whitelistedDomains: environment.whitelist
    };
}

@NgModule({
    imports: [
        JwtModule.forRoot({
          jwtOptionsProvider: {
            provide: JWT_OPTIONS,
            useFactory: authHttpServiceFactory,
            deps: [LoginService]
          }
        })
    ],
    providers: [LoginService]
})
export class AuthModule {}
